import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6822fbc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fault-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "未在炸机24小时内报修提单"),
  /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " * 根据意外机损保险理赔规则，客户需在发生炸机24小时内完成炸机现场的取证并提交故障报修单据以完成理赔维修的报案申请。 ")
], -1))
const _hoisted_3 = { class: "form-wrap" }
const _hoisted_4 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "申诉理由")
], -1))
const _hoisted_6 = { class: "form-wrap" }
const _hoisted_7 = { class: "form-block" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "附图说明")
], -1))
const _hoisted_9 = { class: "upload-wrap" }
const _hoisted_10 = { class: "form-wrap" }
const _hoisted_11 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "申诉理由")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "desc-textarea"
}
const _hoisted_14 = {
  key: 1,
  class: "desc-textarea empty-text"
}
const _hoisted_15 = { class: "form-wrap" }
const _hoisted_16 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "附图说明")
], -1))
const _hoisted_18 = {
  key: 1,
  class: "desc-textarea empty-text"
}
const _hoisted_19 = { class: "form-wrap" }
const _hoisted_20 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "申诉结果")
], -1))
const _hoisted_22 = {
  key: 1,
  class: "desc-textarea empty-text"
}
const _hoisted_23 = { class: "form-wrap" }
const _hoisted_24 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "审批意见")
], -1))
const _hoisted_26 = {
  key: 0,
  class: "desc-textarea"
}
const _hoisted_27 = {
  key: 1,
  class: "desc-textarea empty-text"
}
const _hoisted_28 = { class: "form-wrap" }
const _hoisted_29 = { class: "form-block nongfu-field-placeholder-wrap" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "附图")
], -1))
const _hoisted_31 = {
  key: 1,
  class: "desc-textarea empty-text"
}

import { Field, Button } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { CommonUploaderFileListItem } from '@/types/public'
import { Ref, ref, reactive, computed, onMounted } from 'vue'
import { USER_AFTERSALE_REPAIR_CAMERA_AUTH } from '@/config/constant'
import { GetFlyLogAppealDetailResult } from '@/types/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { flyLogAppeal, GetFlyLogAppealDetail } from '@/apis/malfunction-repair'
import { clearToast, showConfirmModal, showToastLoading, showToastSuccess } from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import UploadImage from '@/components/upload/UploadImage.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import CommonImagePreview from '@/components/CommonImagePreview.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'repair-order-overtime-appeal',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const { removeOrderRepairDetailItemKeepAlive, removeServiceOrderKeepAlive } =
  useMalfunctionRepairStore()
const isFirst = $route.query.first === '1'
const isFromServiceOrder = $route.query.from === 'service'
const serviceGuid = $route.query.serviceGuid as string
const repair_sn = $route.query.repair_sn as string
const isCheck = ref(!isFirst)
const appealImageList: Ref<CommonUploaderFileListItem[]> = ref([])
const canSubmit = computed(() => {
  const imagesList = appealImageList.value
  // 不强制上传图片，但上传成功前不给提交
  return (
    !isCheck.value &&
    form.description.trim() &&
    imagesList.filter((item) => item.status === 'uploading').length === 0
  )
})
const form = reactive({
  description: '',
  images: [],
})
const appealDetail: Ref<null | GetFlyLogAppealDetailResult> = ref(null)
function imageListChange(data: CommonUploaderFileListItem[]) {
  appealImageList.value = data
    .filter((item) => item.url && item.status === 'done')
    .map((item) => ({ ...item, content: '' }))
}

async function initAppealDetail() {
  showToastLoading()
  try {
    const data = await GetFlyLogAppealDetail(repair_sn)
    appealDetail.value = data
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
  }
}
async function submitHandle() {
  const params = {
    guid: serviceGuid,
    description: form.description,
    images: appealImageList.value.map((item) => item?.response?.guid).filter((val) => val),
  }
  try {
    await showConfirmModal({
      message: '确认是否提交申诉？',
      className: 'repair-dialog',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    await flyLogAppeal(params)
    showToastSuccess('提交成功')
    if (isFromServiceOrder) {
      removeServiceOrderKeepAlive()
    } else {
      removeOrderRepairDetailItemKeepAlive()
    }
    setTimeout(() => {
      $router.go(-1)
    }, 1500)
  } catch (error) {
    commonErrorHandle(error)
  }
}

onMounted(() => {
  if (isCheck.value) {
    initAppealDetail()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "报修超时申诉" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!isCheck.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_unref(Field), {
                  rows: "3",
                  type: "textarea",
                  maxlength: "200",
                  class: "desc-textarea",
                  modelValue: form.description,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.description) = $event)),
                  placeholder: "请输入申诉理由"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(UploadImage, {
                    onChange: imageListChange,
                    defaultList: appealImageList.value,
                    cameraAuthKey: _unref(USER_AFTERSALE_REPAIR_CAMERA_AUTH)
                  }, null, 8, ["defaultList", "cameraAuthKey"])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (isCheck.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                (appealDetail.value?.appeal_info?.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(appealDetail.value?.appeal_info?.description), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, "暂无"))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                (appealDetail.value?.appeal_info?.images?.length > 0)
                  ? (_openBlock(), _createBlock(CommonImagePreview, {
                      key: 0,
                      guids: appealDetail.value?.appeal_info?.images
                    }, null, 8, ["guids"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, "暂无"))
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                (appealDetail.value?.verified_result_text)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["desc-textarea", appealDetail.value.verified_result === 1 ? 'text-red' : ''])
                    }, _toDisplayString(appealDetail.value?.verified_result_text), 3))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, "暂无"))
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                (appealDetail.value?.verified_description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(appealDetail.value?.verified_description), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, "暂无"))
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                (appealDetail.value?.verified_images?.length)
                  ? (_openBlock(), _createBlock(CommonImagePreview, {
                      key: 0,
                      guids: appealDetail.value?.verified_images
                    }, null, 8, ["guids"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, "暂无"))
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (!isCheck.value)
      ? (_openBlock(), _createBlock(CommonFooterNextButton, {
          key: 0,
          onClick: submitHandle,
          title: "提交",
          disabled: !_unref(canSubmit)
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (isCheck.value && (appealDetail.value?.can_appeal || appealDetail.value?.can_re_appeal))
      ? (_openBlock(), _createBlock(CommonFooterWrap, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              square: "",
              type: "success",
              class: "xa-vant-button-cancel btn-cancel",
              onClick: _cache[1] || (_cache[1] = () => (isCheck.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 再次申诉 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})